import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/Input";

type Props = {
  open: boolean;
  identifier: string | null;
  error: string | null;
  isConfirming: boolean;
  isResending: boolean;
  onConfirm: (code: string) => void;
  onResend: () => void;
  onClose: () => void;
};

// Asks for the code the API sent to the new phone or email (SFAPI-207).
const IdentifierVerificationDialog = ({
  open,
  identifier,
  error,
  isConfirming,
  isResending,
  onConfirm,
  onResend,
  onClose,
}: Props) => {
  const [code, setCode] = useState("");

  useEffect(() => {
    if (open) setCode("");
  }, [open, identifier]);

  const target = identifier?.includes("@")
    ? `à ${identifier}`
    : `au ${identifier ?? ""}`;

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirmez votre nouvel identifiant</DialogTitle>
          <DialogDescription>
            Saisissez le code envoyé {target}. Il expire dans 10 minutes. Votre
            identifiant actuel reste valable tant que le code n'est pas
            confirmé.
          </DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (code.trim() !== "") onConfirm(code);
          }}
          className="space-y-4"
        >
          <Input
            label="Code de vérification"
            id="identifier-code"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            error={error ?? undefined}
          />
          <DialogFooter className="gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={onResend}
              isLoading={isResending}
            >
              Renvoyer le code
            </Button>
            <Button type="submit" isLoading={isConfirming}>
              Confirmer
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default IdentifierVerificationDialog;
